import { Box, Skeleton, Stack } from "@mui/material";
import React from "react";
import MetricsCard from "./MetricsCard";
import { useSelector } from "react-redux";
import {
  getCurrencySymbol,
  percentageChange,
  roundIfDecimal,
} from "../../../Utils/Utils";

const MetricsContainer = ({
  metrics,
  isLoading,
  doComparison,
  comparisonMetrics,
}) => {
  const hotels = useSelector((state) => state.auth.hotels);
  const currency = getCurrencySymbol(hotels[0]?.hotelCurrency);
  if (isLoading) {
    return (
      <Box height={"160px"}>
        <Skeleton
          variant="rounded"
          width={"100%"}
          height={160}
          animation="wave"
          sx={{
            borderRadius: "8px",
            "&.MuiSkeleton-root": {
              backgroundColor: "#b6bed350",
            },
          }}
        />
      </Box>
    );
  }
  return (
    <Stack direction="row" spacing={2} alignItems="center">
      {[
        {
          title: "Total Revenue",
          value:
            currency +
            roundIfDecimal(metrics?.totalRevenue, 0)?.toLocaleString(),
          comparedValue:
            currency +
            roundIfDecimal(
              comparisonMetrics?.totalRevenue,
              0
            )?.toLocaleString(),
          percentageChange: percentageChange(
            metrics?.totalRevenue,
            comparisonMetrics?.totalRevenue
          ),
        },
        {
          title: "Avg. Occupancy",
          value: roundIfDecimal(metrics?.occupancy, 0) + "%",
          comparedValue:
            roundIfDecimal(comparisonMetrics?.occupancy, 0)?.toLocaleString() +
            "%",
          percentageChange: percentageChange(
            metrics?.occupancy,
            comparisonMetrics?.occupancy
          ),
        },
        {
          title: "ADR",
          value: currency + roundIfDecimal(metrics?.adr, 0)?.toLocaleString(),
          comparedValue:
            currency +
            roundIfDecimal(comparisonMetrics?.adr, 0)?.toLocaleString(),
          percentageChange: percentageChange(
            metrics?.adr,
            comparisonMetrics?.adr
          ),
        },
        {
          title: "RevPAR",
          value:
            currency + roundIfDecimal(metrics?.revPar, 0)?.toLocaleString(),
          comparedValue:
            currency +
            roundIfDecimal(comparisonMetrics?.revPar, 0)?.toLocaleString(),
          percentageChange: percentageChange(
            metrics?.revPar,
            comparisonMetrics?.revPar
          ),
        },
        // {
        //   title: "Pickup",
        //   value: metrics?.totalroomsSold,
        // },
      ].map((item) => (
        <MetricsCard
          title={item?.title}
          value={item?.value}
          isLoading={isLoading}
          doComparison={doComparison}
          comparedValue={item?.comparedValue}
          percentageChange={item?.percentageChange}
        />
      ))}
    </Stack>
  );
};

export default MetricsContainer;
